import './action-button.less';
import {boolOr} from "utils/helpers";
import { PropsWithChildren } from 'react';

interface Props {
  className?: string
  noBorder?: boolean
  onClick?: () => void
  disabled?: boolean
  hasArrow?: boolean
}

export default function ActionButton(props: PropsWithChildren<Props>) {
  const {className, children, noBorder,  onClick, disabled} = props;
  const hasArrow = boolOr(props.hasArrow, true)
  let clazz = "btn btn-primary btn-action";
  if (className) {
    clazz += " " + className;
  }
  if (noBorder) {
    clazz += " no-border";
  }


  return (
    <button className={clazz} onClick={onClick} disabled={disabled}>
      <span className="content">
        {children}
      </span>
      {hasArrow &&
        <i className="icon">{' '}</i>
      }
    </button>
  )
}